import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function getExtensionFromUrl(value: string | undefined | null) {
  if (!value) return null

  const match = value.match(/\.([0-9a-z]+)(?:[?#]|$)/i)
  return match ? `.${match[1]}` : null
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function openUrlInWindow(url: string, windowName = '_blank') {
  window.open(url, windowName)
}

export function getCurrencyValue(
  value: string | number | null | undefined,
  currency: string = 'USD',
) {
  if (!value) return null
  const amount = Number.parseFloat(value as string)

  // Format the amount as a dollar amount
  const formatMap = {
    COP: 'es-CO',
    USD: 'en-US',
  }
  const locale = formatMap[currency as keyof typeof formatMap]
    ? formatMap[currency as keyof typeof formatMap]
    : 'en-US'

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency as string,
  }).format(amount)

  return `${formatted}`
}

export function getTimeAgo(dateInput?: Date | string): string {
  if (!dateInput) return ''
  const inputDate = typeof dateInput === 'string' ? new Date(dateInput) : dateInput
  const now = new Date()

  // Delete hours only to compare dates
  const oneDayMs = 1000 * 60 * 60 * 24
  const diffTime = now.getTime() - inputDate.getTime()
  const diffDays = Math.floor(diffTime / oneDayMs)

  if (diffDays === 0) return 'Today'
  if (diffDays === 1) return '1 day ago'
  if (diffDays < 7) return `${diffDays} days ago`
  if (diffDays < 14) return '1 week ago'
  if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`
  if (diffDays < 60) return '1 month ago'
  if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`

  const years = Math.floor(diffDays / 365)
  return years === 1 ? '1 year ago' : `${years} years ago`
}

export function stripHtml(html: string): string {
  const div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || div.innerText || ''
}
